export default __webpack_public_path__ + "static/media/DNo.11-6.77dbf30b.jpg";